module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-summary"
  }, [_c('h1', [_vm._v("年度汇总报表")]), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.toggle_level()
      }
    }
  }, [_vm._v(_vm._s(_vm.level) + " 级科目")]), _c('month-select', {
    attrs: {
      "start": _vm.date_start,
      "end": _vm.date_end,
      "mode": _vm.mode
    },
    on: {
      "update:start": function($event) {
        _vm.date_start = $event
      },
      "update:end": function($event) {
        _vm.date_end = $event
      }
    }
  }), _c('balance-bar', {
    attrs: {
      "date": _vm.date_end,
      "state": _vm.state
    }
  }), _c('table', {
    staticClass: "ui celled structured table olive"
  }, [_c('thead', [_c('th', {
    staticClass: "center aligned"
  }, [_vm._v("科目")]), _vm._l((_vm.month), function(m) {
    return [_c('th', {
      staticClass: "center aligned"
    }, [_vm._v(_vm._s(m) + "月")])]
  }), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("匯總")])], 2), _c('tbody', [_vm._l((_vm.data[_vm.level].bills), function(row, irow) {
    return _c('tr', {
      class: {
        summary: irow === _vm.data[_vm.level].length - 1
      }
    }, [(_vm.level == 1) ? _c('td', [_vm._v(_vm._s(row._id.subject1))]) : (_vm.level == 2) ? _c('td', [_vm._v(_vm._s(row._id.subject1) + " - " + _vm._s(row._id.subject2))]) : (_vm.level == 3) ? _c('td', [_vm._v(_vm._s(row._id.subject1) + " - " + _vm._s(row._id.subject2) + " - " + _vm._s(row._id.subject3))]) : _vm._e(), _vm._l((_vm.month), function(m) {
      return [_c('td', {
        staticClass: "right aligned"
      }, [_vm._v(_vm._s(_vm.$formatters.money(((row.incomes || []).find(function (i) { return i.month === m; }) || {})['income'])))])]
    }), _c('td', {
      staticClass: "right aligned positive"
    }, [_vm._v(_vm._s(_vm.$formatters.money(_vm.sum_by_subject(row))))])], 2)
  }), _c('tr', [_c('td', {
    staticClass: "positive"
  }, [_vm._v("匯總")]), _vm._l((_vm.month), function(m) {
    return [_c('td', {
      staticClass: "right aligned positive"
    }, [_vm._v(_vm._s(_vm.$formatters.money(_vm.sum_by_month(m))))])]
  }), _c('td', {
    staticClass: "right aligned positive"
  }, [_vm._v(_vm._s(_vm.$formatters.money(_vm.sum_total())))])], 2)], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c4ec44","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/reports/Summary.vue
// module id = 549
// module chunks = 0